import { useEffect, useRef } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';

export const useIntersectionObserver = (intersectionRatio, callback) => {
	const ref = useRef(null);
	useEffect(() => {
		if (
			isBrowser &&
			ref &&
			ref.current &&
			typeof IntersectionObserver !== 'undefined'
		) {
			const target = ref.current;
			const options = {
				threshold: intersectionRatio
			};
			const observer = new IntersectionObserver((entities) => {
				const [entity] = entities;
				if (entity.intersectionRatio >= intersectionRatio) {
					callback();
					observer.disconnect();
				}
			}, options);
			observer.observe(target);
		}
	}, []);

	return [ref];
};
